<template>
  <div class="myCont">
    <div class="main">
      <div class="infosearch">
        <el-select v-model="status" style="width:120px">
          <el-option label="全部" :value="''"></el-option>
          <el-option label="已上架" value="1"></el-option>
          <el-option label="未上架" value="0"></el-option>
        </el-select>
        <el-input v-model="serviceName" placeholder="输入关键字，按商品标题搜索" @keyup.native="specialCharacter" style="width: 250px;margin:0 10px"></el-input>
        <el-button class="searchBtn" @click="enterSeach"></el-button>
        <el-button class="addMems" @click="addVoucher">新增</el-button>
      </div>
      <div class="vouExper">
        <div class="vouExper_s1" v-for="(item,index) in vouExperion" :key="index">
          <li @click="operaMenu(item)" :class="menuChildIndex == item.value && 'on'"><a href="javascript:;"><b>{{item.name}}（{{item.vouNumb}}）</b></a></li>
        </div>
      </div>
      <el-table v-if="tableData.length > 0" :data="tableData" :height="tableData.length == 10 ? 'auto':'615'" ref="multipleTable" class="myMemTable" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
        <el-table-column align="center" type="index" label="序号" width="80">
          <template slot-scope="scope">
            <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="packageName" label="商品标题" ></el-table-column>
        <el-table-column align="center" prop="storePacks" label="关联套盒/药贴" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-row v-if="scope.row.storePackageChildServices.length > 0">
              <div v-if="menuChildIndex == 4">
                <span v-for="(i,index) in scope.row.storePackageChildServices" :key="index">{{i.serviceName + '(' + i.serviceTimes + '次' + ')'}}{{scope.row.storePackageChildServices.length-1 == index ? '' : '，'}}</span>
              </div>
              <div v-else>
                <span v-for="(i,index) in scope.row.storePackageChildServices" :key="index">{{i.serviceName + '(' + i.serviceTimes + '套' + ')'}}{{scope.row.storePackageChildServices.length-1 == index ? '' : '，'}}</span>
              </div>
            </el-row>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="price" label="商品售价" >
          <template slot-scope="scope">{{scope.row.price ? '￥'+ Number(scope.row.price).toFixed(2) : '--'}}</template>
        </el-table-column>
        <el-table-column align="center" prop="updateDate" label="最近编辑时间"></el-table-column>
        <el-table-column align="center" prop="remarks" label="商品简介" width="280" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="shelfDate" label="上架时间"></el-table-column>
        <el-table-column align="center" prop="statusName" label="上架状态">
         <template slot-scope="scope">
            <span :class="scope.row.status == 0 ? 'redFont' : ''">{{scope.row.statusName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" class-name="operation" width="180">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 0">
              <el-button size="mini" class="delete" @click="toDele(scope.row.id)">删除</el-button>
			        <el-button size="mini" class="onSale" @click="toProsOn(scope.row.id)">上架</el-button>
              <el-button size="mini" type="danger" @click="editPro(scope.row.id)">编辑</el-button>
            </template>
            <template v-else>
              <el-button size="mini" class="lowSale" @click="toProsNo(scope.row.id)">下架</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到商品信息！再核对一下试试</div>
      </template>
      <el-pagination
        v-if="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px;text-align:right"
      ></el-pagination>
    </div>
  </div>
</template>
<script type="text/javascript">
import {queryPackagePageList, updatePackageStatus,deletePackageBase, getPackageCount} from "@/api";
import { formatDate } from '../common/js/date.js'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      status: "",
      serviceName: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      vouExperion:[
        {value:4,name:'体验券',vouNumb:0},
        {value:3,name:'组合套餐',vouNumb:0},
        {value:9,name:'任选套餐',vouNumb:0},
      ],
      menuChildIndex:4,
      fullscreenLoading: false
    };
  },
  created() {
    if(this.$store.state.alivePage == 4 || this.$store.state.alivePage == 3 || this.$store.state.alivePage == 9) {
      this.menuChildIndex =  this.$store.state.alivePage;
    }else{
      this.menuChildIndex = 4;
    }
    this.search();
    this.getPacka();
  },
  activated() {
    if(this.$store.state.alivePage == 4 || this.$store.state.alivePage == 3 || this.$store.state.alivePage == 9) {
      this.menuChildIndex =  this.$store.state.alivePage;
    }else{
      this.menuChildIndex = 4;
    }
    this.search();
    this.getPacka();
  },
  methods: {
    specialCharacter() {
      this.serviceName = this.serviceName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
    },
    getPacka(){
      getPackageCount({storeCode:this.$store.state.userInfo.storeCode}).then(res => {
        res.data.forEach(item => {
          for(let i of this.vouExperion){
            if(i.value == item.type){
              i.vouNumb = item.count;
            }
          }
        });
      })
    },
    editPro(id) {
      // 修改
      this.$router.push("/businessManagementCenter/editid" + id);
    },
    operaMenu(val){ //tab卷
      this.currentPage = 1;
      this.menuChildIndex = val.value;
      this.$store.commit('setAlivePage',this.menuChildIndex);
      this.search();
    },
    addVoucher() {// 新增服务商品
      if(this.menuChildIndex){
        this.$router.push("/businessManagementCenter/addVoucher=" + this.menuChildIndex);
      }else{
        this.$router.push("/businessManagementCenter/addVoucher=" + 4);
      }

    },
    search() {
      this.fullscreenLoading = true;
      queryPackagePageList({
        status: this.status,
        packageName: this.serviceName,
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        packageType: this.menuChildIndex,
        storeCode:this.$store.state.userInfo.storeCode
      }).then(res =>{
        if(res.code == 1){
          this.fullscreenLoading = false;
          this.total = res.data.total;
          this.tableData = res.data.rows;
          this.tableData.forEach(item => {
            if(item.updateDate){item.updateDate = formatDate(item.updateDate, 'yyyy-MM-dd')}
            if(item.shelfDate){item.shelfDate = formatDate(item.updateDate, 'yyyy-MM-dd')}
          });
        }
      });
    },
    enterSeach() {
      this.currentPage = 1;
      this.search();
      this.getPacka();
    },
    toDele(id) { //删除
      this.$alert("<h2>确定要删除该商品吗？</h2>", "", {
        dangerouslyUseHTMLString: true,
        customClass: "memBox",
        showCancelButton: true,
        cancelButtonText: "取消",
        cancelButtonClass: "darkBtn",
        confirmButtonClass: "redBtn",
        closeOnClickModal: true
      }).then(({ value }) => {
          deletePackageBase({
            id: id,
            creatorId:this.$store.state.userInfo.staffId,
            createName:this.$store.state.userInfo.staffName
          }).then(res => {
            this.search();
			      this.getPacka();
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    toProsOn(id) {// 上架
      this.$alert("<h2>确定要上架该商品吗？</h2>", "", {
        dangerouslyUseHTMLString: true,
        customClass: "memBox",
        showCancelButton: true,
        cancelButtonText: "取消",
        cancelButtonClass: "darkBtn",
        confirmButtonClass: "redBtn",
        closeOnClickModal: true
      }).then(({ value }) => {// 上架
          updatePackageStatus({
            id: id,
            status: "1"
          }).then(res => {
            this.search();
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    toProsNo(id) {// 下架
      this.$alert("<h2>确定要下架该商品吗？</h2><p>下架之后商品在小程序和app商城中无法查看到该商品。</p>", "",{
          dangerouslyUseHTMLString: true,
          customClass: "memBox",
          showCancelButton: true,
          cancelButtonText: "取消",
          cancelButtonClass: "darkBtn",
          confirmButtonClass: "redBtn",
          closeOnClickModal: true
        }).then(({ value }) => { // 下架
          updatePackageStatus({
            id: id,
            status: "0"
          }).then(res => {
            this.search();
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  }
};
</script>
<style lang="less" scoped>
.main {
  padding: 25px 0;
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;margin-left:10%;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
    .checkBoxcom {
      margin: 0 40px 0 50px;
    }
  }
  .myMemTable {
    border: 1px solid #d5d9e3;
    .redFont {
      color: #f83b56; //表格内红色字
    }
    .blueFont {
      color: #21a3f5; //表格内蓝色字
    }
    .onSale {
      background: #2ecfa7;border:#2ecfa7;
      color: #fff;
    }
    .delete {
      color: #f83b56;
      border: 1px solid #f83b56;
    }
    .lowSale {
      background: #ffb932;
      color: #fff;
      border:#ffb932;
    }
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.operation {
  .cell {
    padding: 0;
  }
}
.myMemTable {
  .mySortTab {
    padding: 0;
    .el-form-item__content {
      .el-input {
        width: 60px;
        .el-input__inner {
          text-align: center;
        }
      }
      .el-form-item__error {
        position: relative;
        white-space: nowrap;
      }
    }
  }
  .el-input__inner,
  .el-input__inner:focus {
    border: 1px solide #f83b56;
    border-color: #f83b56;
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/voucher.vue